import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-155b3626")
const _hoisted_1 = {
  key: 0,
  id: "loading-screen-component"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-container-ph" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-ph" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "logo-ph" }),
    /*#__PURE__*/_createElementVNode("div", { id: "header-buttons-ph" }, [
      /*#__PURE__*/_createElementVNode("div", {
        id: "save-template-btn-ph",
        class: "btn save"
      }),
      /*#__PURE__*/_createElementVNode("div", {
        id: "save-template-btn-ph",
        class: "btn save"
      }),
      /*#__PURE__*/_createElementVNode("div", { id: "save-continue-ph" })
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "main-container-ph" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "sidetoolbar-ph-container" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "sidetoolbar-ph" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "tool-icon-ph" }),
      /*#__PURE__*/_createElementVNode("div", { class: "tool-icon-ph" }),
      /*#__PURE__*/_createElementVNode("div", { class: "tool-icon-ph" }),
      /*#__PURE__*/_createElementVNode("div", { class: "tool-icon-ph" }),
      /*#__PURE__*/_createElementVNode("div", { class: "tool-icon-ph" }),
      /*#__PURE__*/_createElementVNode("div", { class: "tool-icon-ph" }),
      /*#__PURE__*/_createElementVNode("div", { id: "settingPH" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { id: "canvas-ph-container" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "PH" }),
    /*#__PURE__*/_createElementVNode("div", { id: "canvas-ph" }, [
      /*#__PURE__*/_createElementVNode("div", { id: "fade-ph" }, [
        /*#__PURE__*/_createElementVNode("div", { id: "canvas-cutline" }, [
          /*#__PURE__*/_createElementVNode("div", { id: "canvas-logo-ph-container" }, [
            /*#__PURE__*/_createElementVNode("div", { id: "canvas-logo-ph" }),
            /*#__PURE__*/_createElementVNode("div", { id: "canvas-text" }, " Design & Print Software ")
          ]),
          /*#__PURE__*/_createElementVNode("div", { id: "loading-dots-container" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "loading-dots" }),
            /*#__PURE__*/_createElementVNode("div", { class: "loading-dots" }),
            /*#__PURE__*/_createElementVNode("div", { class: "loading-dots" })
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { id: "bottom-drop-down" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
        /*#__PURE__*/_createElementVNode("div", { id: "bg-ph" }),
        /*#__PURE__*/_createElementVNode("div", { id: "orientation-ph" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { id: "right" })
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.appIsLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}